
import React, { useLayoutEffect } from 'react'
import smoothscroll from 'smoothscroll-polyfill'
// State Mgmt
import { CourseStateProvider } from '../../state/courseStore'
// Internationalising
import LanguageWrapper from './LanguageWrapper'

// Styling
import GlobalStyle from '../../styles/global'
import { ThemeProvider } from 'styled-components'
import theme from '../../styles/theme'
import { setViewportProps } from '../../utils/setViewportProps'
import Layout from '../Layout'

const App = () => {
  useLayoutEffect(() => {
    smoothscroll.polyfill()
    setViewportProps()
    window.addEventListener('resize', () => {
      setViewportProps()
    })
    return () => {
      window.addEventListener('resize', () => {})
    }
  })
  const course = window?.location?.pathname?.includes('regning') ? 'regning' : 'leseskrive'
  return (
    <CourseStateProvider course={course}>
      <LanguageWrapper course={course}>
        <ThemeProvider theme={theme} course={course}>
          <GlobalStyle />
          <Layout />
        </ThemeProvider>
      </LanguageWrapper>
    </CourseStateProvider>
  )
}

export default App
